require('../../modules/es.symbol');
var path = require('../../internals/path');

module.exports = path.Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/es/object/get-own-property-symbols.js
// module id = 443
// module chunks = 0